<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{ data?.id ? 'Edit warranty' : 'Create warranty' }}
    </div>
  </div>
  <div class="details flex-1">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="name"
    />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['description']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="description"
      label="description"
    />
    <app-date-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['start_date']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="start_date"
      label="start date"
    />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['period_months']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="period_months"
      label="duration (months)"
    />

    @if (form.get('start_date')?.value && form.get('period_months')?.value) {
      <div class="row-details flex flex-col gap-[12px] mb-[30px]">
        <div class="label w-full uppercase">Computed End Date:</div>
        <div class="value w-full text-type-11">{{ getEndDate() }}</div>
      </div>
    }

    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['status']"
      [options]="statusOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="status"
      label="status"
    />

    <!-- Contractor Selection -->
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['contractor_id']"
      [options]="contractorOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="contractor_id"
      label="contractor"
    />

    <!-- Warranty Users -->
    <div class="warranty-users-section mb-[20px]">
      <div class="text-type-13 uppercase mb-[12px]">Warranty Users</div>

      @if (selectedAccounts.length) {
        <div class="user-list mb-[16px]">
          @for (account of selectedAccounts; track account.account_id) {
            <div class="user-item flex flex-row items-center justify-between py-[8px]">
              <div class="flex flex-col">
                <span class="text-type-8">{{ account.first_name }} {{ account.last_name }}</span>
                <span class="text-type-14 text-[#60698B]">{{ account.email }}</span>
              </div>
              <button (click)="removeUser(account)" class="remove-user-btn">
                <mat-icon svgIcon="trash" />
              </button>
            </div>
            <hr class="hr-line" />
          }
        </div>
      }

      @if (!showNewUserForm) {
        <app-dropdown
          (addNewClicked)="toggleNewUserForm()"
          [enableAddNew]="true"
          [enableSearch]="true"
          [enableMultiple]="true"
          [showCount]="true"
          [selectionString]="'users'"
          [addNewLabel]="'Add new contractor user'"
          [options]="memberOptions"
          [parentFormGroup]="userSelectForm"
          class="w-full mb-[20px]"
          controlName="selectedUser"
          label="select or add user"
          placeholder="Select"
        />
      }

      @if (showNewUserForm) {
        <app-text-input
          [parentFormGroup]="newUserForm"
          class="w-full mb-[20px]"
          controlName="firstName"
          label="first name"
        />
        <app-text-input
          [parentFormGroup]="newUserForm"
          class="w-full mb-[20px]"
          controlName="lastName"
          label="last name"
        />
        <app-text-input
          [parentFormGroup]="newUserForm"
          class="w-full mb-[20px]"
          controlName="email"
          label="email"
        />
        <app-text-input
          [parentFormGroup]="newUserForm"
          class="w-full mb-[20px]"
          controlName="phone"
          label="phone"
        />
        <div class="flex flex-row gap-[12px] mb-[20px]">
          <app-secondary-button (handleClick)="toggleNewUserForm()" class="flex-1">Cancel</app-secondary-button>
          <app-primary-button (handleClick)="addNewUser()" [isDisabled]="!newUserForm.valid" class="flex-1">Add</app-primary-button>
        </div>
      }
    </div>

    <div class="reminder-section mt-[20px]">
      <div class="text-type-13 uppercase mb-[20px]">Reminder Thresholds (days before expiry)</div>
      <div class="reminder-chips flex flex-row flex-wrap gap-[8px] mb-[16px]">
        @for (day of reminderDays; track day) {
          <span class="reminder-chip px-[14px] rounded-full">
            {{ day }} days
            <button type="button" (click)="removeReminder(day)" class="chip-remove">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        }
      </div>
      <div class="add-reminder flex flex-row items-center gap-[12px]">
        <input
          [(ngModel)]="newReminderDay"
          class="reminder-input"
          type="number"
          min="1"
          placeholder="Days"
        />
        <app-secondary-button (handleClick)="addReminder()" [isDisabled]="!newReminderDay" class="!w-[80px]">
          Add
        </app-secondary-button>
      </div>
    </div>
  </div>
  <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="w-full">
      {{ data?.id ? 'Update' : 'Create' }}
    </app-primary-button>
  </div>
</div>
